<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Date">
              <b-datepicker
                v-model="date"
                name="date"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Date"
              />
            </b-field>
            <b-field label="Region">
              <multiselect
                v-model="selectedRegion"
                :options="regions"
                :multiple="true"
                label="name"
                track-by="name"
                :close-on-select="false"
                placeholder="Pick region"
                style="min-width: 400px;"
              />
            </b-field>
            <b-field label="Country">
              <multiselect
                v-model="selectedCountry"
                :options="countries"
                :multiple="true"
                :close-on-select="false"
                placeholder="Pick country"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
            <b-button
              class="left-right ml-3"
              type="is-success"
              icon-left="download"
              :disabled="!isLoaded || isLoading"
              @click="() => {exportToExcel()}"
            >
              Export xlsx
            </b-button>
          </b-field>
          <div
            v-for="plant in stocks"
            :key="plant.id_site"
            class="card"
            :style="{
              'padding': '1rem',
              'margin-bottom': '1rem'
            }"
          >
            <div>
              {{ plant.name + ' ' + plant.id_site }}
            </div>
            <div class="columns">
              <div class="column is-2">
                <div>
                  GPS 5 Stocks
                </div>
                <div>
                  {{ 'Clean: ' + plant.clean5 }}
                </div>
                <div>
                  {{ 'Dirty: ' + plant.dirty5 }}
                </div>
                <div>
                  {{ 'Repair: ' + plant.repair5 }}
                </div>
              </div>
              <div class="column is-2">
                <div>
                  GPS 1 Stocks
                </div>
                <div>
                  {{ 'Clean: ' + plant.clean1 }}
                </div>
                <div>
                  {{ 'Dirty: ' + plant.dirty1 }}
                </div>
                <div>
                  {{ 'Repair: ' + plant.repair1 }}
                </div>
              </div>
              <div class="column">
                <div>
                  Safety Stocks
                </div>
                <table style="border-collapse: separate; border-spacing: 1rem 0;">
                  <tr>
                    <td>
                      Status
                    </td>
                    <td>
                      Safety
                    </td>
                    <td>
                      Current
                    </td>
                    <td>
                      %
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Available:
                    </td>
                    <td>
                      {{ plant.min_available }}
                    </td>
                    <td>
                      {{ plant.available }}
                    </td>
                    <td>
                      {{ plant.min_available && plant.min_available !== 0 ? (plant.available/plant.min_available * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Clean:
                    </td>
                    <td>
                      {{ plant.min_clean }}
                    </td>
                    <td>
                      {{ plant.clean }}
                    </td>
                    <td>
                      {{ plant.min_clean && plant.min_clean !== 0 ? (plant.clean/plant.min_clean * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dirty:
                    </td>
                    <td>
                      {{ plant.min_dirty }}
                    </td>
                    <td>
                      {{ plant.dirty }}
                    </td>
                    <td>
                      {{ plant.min_dirty && plant.min_dirty !== 0 ? (plant.dirty/plant.min_dirty * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Repair:
                    </td>
                    <td>
                      {{ plant.min_repair }}
                    </td>
                    <td>
                      {{ plant.repair }}
                    </td>
                    <td>
                      {{ plant.min_repair && plant.min_repair !== 0 ? (plant.repair/plant.min_repair * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="column">
                <div>
                  Max Stocks
                </div>
                <table style="border-collapse: separate; border-spacing: 1rem 0;">
                  <tr>
                    <td>
                      Status
                    </td>
                    <td>
                      Max
                    </td>
                    <td>
                      Current
                    </td>
                    <td>
                      %
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ 'Clean: ' }}
                    </td>
                    <td>
                      {{ plant.max_clean }}
                    </td>
                    <td>
                      {{ plant.clean }}
                    </td>
                    <td>
                      {{ plant.max_clean && plant.max_clean !== 0 ? (plant.clean/plant.max_clean * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ 'Dirty: ' }}
                    </td>
                    <td>
                      {{ plant.max_dirty }}
                    </td>
                    <td>
                      {{ plant.dirty }}
                    </td>
                    <td>
                      {{ plant.max_dirty && plant.max_dirty !== 0 ? (plant.dirty/plant.max_dirty * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ 'Total: ' }}
                    </td>
                    <td>
                      {{ plant.max_total }}
                    </td>
                    <td>
                      {{ plant.total }}
                    </td>
                    <td>
                      {{ plant.max_total && plant.max_total !== 0 ? (plant.total/plant.max_total * 100).toFixed(0) + '%' : '' }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import Stock from '../../services/v3/crateStock'
import XLSX from 'xlsx'
import plantSelector from '@/mixins/plantSelector'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'WorldStock',
  components: {
  },
  mixins: [plantSelector],
  data: function () {
    return {
      date: new Date(),
      isLoading: false,
      isLoaded: false,
      countries: [],
      regions: [],
      selectedCountry: null,
      selectedRegion: null,
      stocks: [],
      crateStocks: [],
      movements: [],
      modules: AllModules
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    // This view is not scoped to a group, it always reports on every site.
    await this.loadPlants({ force: true })
    this.countries = [...new Set(this.plants.map((element) => {
      return element.countryCode + ' - ' + element.country
    }))].sort()
    this.regions = [
      {
        name: 'Europe',
        plants: [
          'PLC1',
          'PLC3',
          'PLC6',
          'DEA0',
          'HUC0',
          'CZC0',
          'FRA0',
          'FRA1',
          'FRA2',
          'ITC1',
          'GBA0',
          'ESC1'
        ]
      },
      {
        name: 'North America',
        plants: [
          'USA0',
          'USA1',
          'USA3',
          'USA4',
          'USC2',
          'USC6',
          'USC3',
          'MXC0',
          'CAC0',
          'CAC1',
          'CAC2',
          'CAC3'
        ]
      },
      {
        name: 'Latin America',
        plants: [
          'BRC0',
          'BRC1',
          'GTC0'
        ]
      },
      {
        name: 'Russia',
        plants: [
          'RUC2',
          'RUC4',
          'RUC5'
        ]
      },
      {
        name: 'Africa',
        plants: [
          'CIA0',
          'CIA1'
        ]
      },
      {
        name: 'East Asia',
        plants: [
          'CNA0',
          'CNC3',
          'CND2',
          'CND1',
          'CNJ2',
          'KRC0',
          'TWC0',
          'TWC2',
          'JPC1',
          'JPC3',
          'JPC5',
          'JPC7',
          'JPC8'
        ]
      },
      {
        name: 'Southeast Asia',
        plants: [
          'THC0',
          'THC1',
          'THC2',
          'THC5',
          'THC6',
          'IDC0',
          'IDC1',
          'IDC4',
          'IDC6',
          'IDC7',
          'IDC8',
          'SGA0',
          'MYA0',
          'INH0',
          'INH3',
          'INC1',
          'INC4',
          'INC5'
        ]
      }
    ]
  },
  methods: {
    resetData () {
      this.stocks = []
    },
    async getData () {
      this.isLoading = true
      this.stocks = []
      this.movements = []
      this.$buefy.toast.open({ message: 'Loading Data', duration: 10000, type: 'is-success' })
      try {
        let tempPlants = []
        if (this.selectedRegion !== null) {
          this.selectedRegion.forEach((y) => {
            tempPlants = tempPlants.concat(y.plants)
          })
        }
        if (this.selectedCountry !== null) {
          this.selectedCountry.forEach((z) => {
            tempPlants = tempPlants.concat(this.plants.filter((x) => {
              return x.countryCode === z.split(' - ')[0]
            }).map((element) => {
              return element.id
            })
            )
          })
        }
        const data = await Stock.getWorld({
          date: this.date.toLocaleDateString('en-CA'),
          plants: tempPlants
        })
        data.forEach((element, index) => {
          this.stocks.push({
            id_site: element.plant.id,
            name: element.plant.name,
            clean5: element.stock.filter((x) => {
              return x.status === '5.2__CLEAN' || x.status === '5.1__CLEAN' || x.status === '5.5__CLEAN'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            dirty5: element.stock.filter((x) => {
              return x.status === '5.2__DIRTY' || x.status === '5.1__DIRTY' || x.status === '5.5__DIRTY'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            repair5: element.stock.filter((x) => {
              return x.status === '5.2__REPAIR' || x.status === '5.1__REPAIR' || x.status === '5.5__REPAIR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            clean1: element.stock.filter((x) => {
              return x.status === '1__CLEAN'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            dirty1: element.stock.filter((x) => {
              return x.status === '1__DIRTY'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            repair1: element.stock.filter((x) => {
              return x.status === '1__REPAIR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            max_clean: element.target && element.target.length > 0 ? element.target[0].max_clean : 0,
            max_dirty: element.target && element.target.length > 0 ? element.target[0].max_dirty : 0,
            max_total: element.target && element.target.length > 0 ? element.target[0].max_total : 0,
            min_available: element.target && element.target.length > 0 ? element.target[0].min_available : 0,
            min_clean: element.target && element.target.length > 0 ? element.target[0].min_clean : 0,
            min_dirty: element.target && element.target.length > 0 ? element.target[0].min_dirty : 0,
            min_repair: element.target && element.target.length > 0 ? element.target[0].min_repair : 0,
            clean: element.stock.filter((x) => {
              return (x.status === '5.2__CLEAN' || x.status === '5.1__CLEAN' || x.status === '5.5__CLEAN' || x.status === '1__CLEAN') && x.num_crates > 0
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            dirty: element.stock.filter((x) => {
              return (x.status === '5.2__DIRTY' || x.status === '5.1__DIRTY' || x.status === '5.5__DIRTY' || x.status === '1__DIRTY') && x.num_crates > 0
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            repair: element.stock.filter((x) => {
              return (x.status === '5.2__REPAIR' || x.status === '5.1__REPAIR' || x.status === '5.5__REPAIR' || x.status === '1__REPAIR') && x.num_crates > 0
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            available: element.stock.filter((x) => {
              return (x.status === '5.2__CLEAN' || x.status === '5.1__CLEAN' || x.status === '5.5__CLEAN' || '1__CLEAN' || x.status === '5.2__DIRTY' || x.status === '5.1__DIRTY' || x.status === '5.5__DIRTY' || x.status === '1__DIRTY') && x.num_crates > 0
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0),
            total: element.stock.filter((x) => {
              return x.num_crates > 0
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
          })
        })
        if (this.stocks.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'Error loading stocks', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
      this.isLoading = false
      this.isLoaded = true
    },
    exportToExcel () {
      var lines = []
      var opts = {
        type: 'string'
      }
      lines.push(['World Stock Status'])
      lines.push(['Date', this.date.toLocaleDateString('en-CA')])
      lines.push(['Plant Name', 'Plant ID', 'GPS 5 Clean', 'GPS 5 Dirty', 'GPS 5 Repair', 'GPS 1 Clean', 'GPS 1 Dirty', 'GPS 1 Repair', 'Safety Available Target', 'Current Available', '% Safety Available', 'Safety Clean Target', 'Current Clean', '% Safety Clean', 'Safety Dirty Target', 'Current Dirty', '% Safety Dirty', 'Safety Repair Target', 'Current Repair', '% Safety Repair', 'Max Clean Storage', 'Current Clean', '% Max Clean', 'Max Dirty Storage', 'Current Dirty', '% Max Dirty', 'Max Total Storage', 'Current Total', '% Max Total'])
      this.stocks.forEach((plant) => {
        lines.push([plant.name, plant.id_site, plant.clean5, plant.dirty5, plant.repair5, plant.clean1, plant.dirty1, plant.repair1, plant.min_available, plant.available, plant.min_available && plant.min_available !== 0 ? (plant.available / plant.min_available * 100).toFixed(0) + '%' : '', plant.min_clean, plant.clean, plant.min_clean && plant.min_clean !== 0 ? (plant.clean / plant.min_clean * 100).toFixed(0) + '%' : '', plant.min_dirty, plant.dirty, plant.min_dirty && plant.min_dirty !== 0 ? (plant.dirty / plant.min_dirty * 100).toFixed(0) + '%' : '', plant.min_repair, plant.repair, plant.min_repair && plant.min_repair !== 0 ? (plant.repair / plant.min_repair * 100).toFixed(0) + '%' : '', plant.max_clean, plant.clean, plant.max_clean && plant.max_clean !== 0 ? (plant.clean / plant.max_clean * 100).toFixed(0) + '%' : '', plant.max_dirty, plant.dirty, plant.max_dirty && plant.max_dirty !== 0 ? (plant.dirty / plant.max_dirty * 100).toFixed(0) + '%' : '', plant.max_total, plant.max_total, plant.max_total && plant.max_total !== 0 ? (plant.total / plant.max_total * 100).toFixed(0) + '%' : ''])
      })
      var workbook = XLSX.utils.book_new()
      var worksheet = XLSX.utils.aoa_to_sheet(lines)
      worksheet['!cols'] = [
        { wch: 23 }, // A
        { wch: 10 }, // B
        { wch: 10 }, // C
        { wch: 9 }, // D
        { wch: 10.25 }, // E
        { wch: 10 }, // F
        { wch: 9 }, // G
        { wch: 10.25 }, // H
        { wch: 19 }, // I
        { wch: 14 }, // J
        { wch: 15 }, // K
        { wch: 16 }, // L
        { wch: 11 }, // M
        { wch: 12 }, // N
        { wch: 15.25 }, // O
        { wch: 11 }, // P
        { wch: 11.5 }, // Q
        { wch: 17 }, // R
        { wch: 12 }, // S
        { wch: 13 }, // T
        { wch: 15.5 }, // U
        { wch: 11.5 }, // V
        { wch: 11 }, // W
        { wch: 15 }, // X
        { wch: 11 }, // Y
        { wch: 10 }, // Z
        { wch: 15 }, // AA
        { wch: 11 }, // AB
        { wch: 10.25 } // AC
      ]
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Bonus')
      XLSX.writeFile(workbook, 'exportedData.xlsx', opts)
    }
  }
}

</script>
